import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import * as actions from "../../actions";

import { withStyles } from '@material-ui/core/styles';




import Button from '@material-ui/core/Button';


import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';


import Divider from '@material-ui/core/Divider';


import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

import ProfileIcon from 'mdi-material-ui/Account'
import StatisticIcon from 'mdi-material-ui/ChartLine'
import PackageIcon from 'mdi-material-ui/PackageVariant'
import PackageClosedIcon from 'mdi-material-ui/PackageVariantClosed'
import LogoutIcon from 'mdi-material-ui/LogoutVariant'
import InfoIcon from 'mdi-material-ui/InformationOutline'
import RadioactiveIcon from 'mdi-material-ui/Radioactive'
import MenuIcon from 'mdi-material-ui/Menu'
import CloseIcon from 'mdi-material-ui/Close'
import BoardIcon from 'mdi-material-ui/ClipboardOutline'

import Drawer from '@material-ui/core/Drawer';


const style = theme => ({



  ///// MOBILE MENU

  dummyContainer:{
    width: "calc(100vw - 250px)",
  },
  paperDrower:{
    background: theme.palette.background.dark,
  },
  mobileMenuContainer:{

    width: "100%",
    height: "100%"
  },

  primary:{
    color: "white",
    fontSize: 15,
  },
  icon:{
    color: "white",
  }

})

function Transition(props) {
  return <Slide direction="left" {...props} />;
}

class MobileNav extends React.Component {
  state = {
    navBarSmall: false,
    menuHidden : false,
    currentScrollPosition: 0,

    showHomeButton: false,

    mobileMenuIsOpened: false,
  }

  static contextTypes = {
    router: PropTypes.object
  }

  goTo = (navLink, data)=>{
    this.toggleMobileMenu()
    this.context.router.history.push(navLink)
    this.props.setNavigationActiveLink(data ? data: "")
  }

  login = ()=>{
    this.toggleMobileMenu()
    this.props.loginDialogState(true)
  }

  toggleMobileMenu = ()=>{
    this.setState({mobileMenuIsOpened: !this.state.mobileMenuIsOpened})
  }

  handleLogOut = () => {
    this.props.signOut()
    this.setState({ mobileMenuIsOpened: false });
  }

  render() {
    const { classes, auth } = this.props;


    return (

          <div >
            <Drawer
              open={this.state.mobileMenuIsOpened}
              onClose={this.toggleMobileMenu}
              anchor="right"
              classes={{paper: classes.paperDrower}}
              >

                <div className={classes.mobileMenuContainer} onClick={this.toggleMobileMenu} onKeyDown={this.toggleMobileMenu}>
                  <div style={{display:"flex", justifyContent:"center"}}>
                      <img style={{padding: 16}} src="https://i.imgur.com/kAfVurb.png" alt="logo" width="auto" height="80px" />
                  </div>
                  {
                    auth ? (
                      <MenuList>
                        <MenuItem className={classes.menuItem}>

                          <ListItemText onClick={this.login} classes={{ primary: classes.primary }}  primary={auth.email} secondary={auth.displayName} />
                        </MenuItem>
                      </MenuList>
                    ) : (
                      <MenuList>
                        <MenuItem className={classes.menuItem}>
                          <Button  onClick={this.login}  variant="contained" color="secondary" fullWidth>
                            PRIJAVA
                          </Button>

                        </MenuItem>
                      </MenuList>
                    )
                  }
                  {auth && (<Divider  style={{background:"white" , margin: 0, marginLeft: 16, marginRight: 16}}  />)}
                  {
                    auth ? (
                      <MenuList>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <PackageIcon />
                          </ListItemIcon>
                          <ListItemText  onClick={()=>this.goTo("/mojestave")} classes={{ primary: classes.primary }} inset primary={"MOJE STAVE"} />
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <PackageClosedIcon />
                          </ListItemIcon>
                          <ListItemText  onClick={()=>this.goTo("/narocilo")} classes={{ primary: classes.primary }} inset primary={"PONUDBA"}/>
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <StatisticIcon />
                          </ListItemIcon>
                          <ListItemText  onClick={()=>this.goTo("/mojestave/statistika")} classes={{ primary: classes.primary }} inset primary={"STATISTIKA"}/>
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <BoardIcon />
                          </ListItemIcon>
                          <ListItemText  onClick={()=>this.goTo("/mojestave/stavneosnove")} classes={{ primary: classes.primary }} inset primary={"STAVNE OSNOVE"}/>
                        </MenuItem>
                        
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <ProfileIcon />
                          </ListItemIcon>
                          <ListItemText  onClick={()=>this.goTo("/mojestave/mojprofil")} classes={{ primary: classes.primary }} inset primary={"PROFIL"}/>
                        </MenuItem>

                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <LogoutIcon />
                          </ListItemIcon>
                          <ListItemText onClick={this.handleLogOut} classes={{ primary: classes.primary }} inset primary={"ODJAVA"} />
                        </MenuItem>
                      </MenuList>
                    ):(
                      <MenuList>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <PackageClosedIcon />
                          </ListItemIcon>
                          <ListItemText onClick={()=>this.goTo("/", "packages")} classes={{ primary: classes.primary }} inset primary="PONUDBA" />
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <StatisticIcon />
                          </ListItemIcon>
                          <ListItemText onClick={()=>this.goTo("/","statistic")} classes={{ primary: classes.primary }} inset primary="STATISTIKA" />
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <InfoIcon />
                          </ListItemIcon>
                          <ListItemText  onClick={()=>this.goTo("/","advices")}  classes={{ primary: classes.primary }} inset primary="STAVNE OSNOVE" />
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                          <ListItemIcon className={classes.icon}>
                            <RadioactiveIcon />
                          </ListItemIcon>
                          <ListItemText onClick={()=>this.goTo("/","betVideos")} classes={{ primary: classes.primary }} inset primary="BREZPLAČNI NASVETI" />
                        </MenuItem>
                      </MenuList>
                    )
                  }


                </div>
                {

                  <Button onClick={this.toggleMobileMenu} variant="fab"  style={{position:"fixed", bottom: 24, right: 24, background: "url(https://i.imgur.com/aW1RwhP.jpg)"}}>
                    <CloseIcon style={{fontSize: 25}}/>
                  </Button>

                }
            </Drawer>
            {

              <Button onClick={this.toggleMobileMenu} variant="fab"  style={{position:"fixed", bottom: 24, right: 24, zIndex:500, background: "url(https://i.imgur.com/aW1RwhP.jpg)"}}>
                <MenuIcon style={{fontSize: 25}}/>
              </Button>

            }
          </div>
    );
  }
}

MobileNav.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ auth, navigationData }) => {
  return {
    auth,
    navigationData
  };
};

export default connect(mapStateToProps, actions)( withStyles(style, { withTheme: true })(MobileNav))



// WEBPACK FOOTER //
// ./src/components/navs/MobileNav.js